import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Table, Loader, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {
  renderTitle,
  renderTable,
} from '../../../../../common/util/partsUtils';
import {Actions} from '../../../../../common/actions';

class StockModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': 0,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {code} = this.props;
    this.props.fetchStockDetail(code, true);
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchStockDetail(code, true);
    }
  }

  handleClick = (e, titleProps) => {
    const {activeIndex} = this.state;
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  };

  renderData() {
    const {loading, stockDetail} = this.props;

    if (loading) {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }
    return renderTable(stockDetail);
  }

  render() {
    const {activeIndex} = this.state;
    const {loading, stockDetail} = this.props;
    const numberAgencies = Object.keys(stockDetail).length;
    let totalStock = 0;
    Object.keys(stockDetail).forEach((agencyName) => {
      totalStock += _.sumBy(stockDetail[agencyName], 'stock');
    });
    return (
      <Accordion fluid>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={this.handleClick}
        >
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  textAlign='left'
                  colSpan={numberAgencies === 0 ? 1 : numberAgencies * 2 - 1}
                >
                  Existencia Concesionarios
                  <span className='quantity-container'>{totalStock}</span>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={1} textAlign='right'>
                  <Icon name='dropdown' />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
          </Table>
        </Accordion.Title>

        <Accordion.Content active={activeIndex === 0}>
          <Table striped className='toyota-grid'>
            <Table.Header>
              {!loading && numberAgencies > 0 && (
                <Table.Row>{renderTitle(stockDetail)}</Table.Row>
              )}
            </Table.Header>

            {this.renderData(stockDetail)}
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.partModals.loadingStockDetail,
    'stockDetail': state.partModals.stockDetail,
  };
};

const {fetchStockDetail} = Actions;

export default connect(mapStateToProps, {
  fetchStockDetail,
})(StockModal);
